var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shippo-attribute-tag",attrs:{"type":_vm.type}},[_vm._v(_vm._s(_vm._f("cap")(_vm.type)))])
}
var staticRenderFns = []

export { render, staticRenderFns }